
// menu
"use strict";

// (function() {
//     var headerToModify = $(".header");
//     var offsetToReach = headerToModify.find('.wrapper').height() - 10;
//     $(window).scroll(function() {
//         var scroll = $(window).scrollTop();
//         if (scroll >= offsetToReach) {
//             headerToModify.addClass("__js_modified");
//         } else if (scroll < offsetToReach) {
//             headerToModify.removeClass("__js_modified");
//         }
//     });
// })();

(function() {
    
    var headerToModify = $(".header.fixed");
    if(!headerToModify.length) { return; }
        
    var offsetToReach = $('.top--full-photo img').height() - 10;
    if(offsetToReach == -10) {offsetToReach = 200;};
    
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= offsetToReach) {
            headerToModify.addClass("visible");
        } else if (scroll < offsetToReach) {
            headerToModify.removeClass("visible");
        }
    });
})();

